var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('action-plan-form',{on:{"validChange":_vm.handleValidChange}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[_c('span',[_vm._v("Plano de ação:")])])
}]

export { render, staticRenderFns }